var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qa"},_vm._l((_vm.qaList),function(item,index){return _c('div',{key:index,staticClass:"qa-item"},[_c('div',{staticClass:"title flex"},[_c('img',{staticClass:"img-icon",attrs:{"src":_vm.imgList[index]}}),_c('div',[_vm._v(_vm._s(item.title))])]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(item.content))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }